import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {setGetSupportList} from '../../store/thunk/setGetSupportList';
import TemplatePage from '../../../components/templatePage';
import SupportItem from '../../components/supportItem';

const Support = () => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setGetSupportList({
            page: 1,
            rowsPerPage: 10,
        }))
    }, [])

    const list = useSelector(state => state.supportMobile.list);

    return (
        <TemplatePage
            title="Техническая поддержка"
        >
            {
                list.map((item) => <SupportItem item={item}/>)
            }
            
        </TemplatePage>
    )
}

export default Support;